import * as _ from "lodash";
import * as angular from "angular";
import { Filter } from "../../models/filter.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { FilterDataProvider } from "../../data-provider/filter.dp";

let ViewFilterDialog = {
    selector: "vcViewFilterDialog",
    templateUrl: "/angular/components/filter/view-filter-dialog.component.html",
    bindings: {
        filters: "=?",
    },
    controller: class ViewFilterDialogController {
        // * bindings for typescript compiler *
        public filters?: any;
        // ************************************

        public filter: Filter;

        private readonly dialog: DialogUtils;
        private readonly dataProvider: FilterDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            FilterDataProvider: FilterDataProvider
        ) {
            this.dialog = DialogUtils;
            this.dataProvider = FilterDataProvider;

            this.filter = new Filter();
        }

        $onInit() {
            this.filter.setData(
                _.merge(this.filter, this.previousFilter(this.filters))
            );

            angular.forEach(this.filters, (_: any, key: string) => {
                this.filter[key].checked = true;
            });

            this.dataProvider.filter = this.filter;
        }

        previousFilter(filters: any): object {
            let new_filters = {};
            let key: string;

            for (key in filters) {
                if (
                    key != "custom_fields" &&
                    key != "elections" &&
                    key != "surveys"
                ) {
                    new_filters[key] = { values: filters[key] };
                } else {
                    new_filters[key] = filters[key];
                }
                new_filters[key].checked = true;
            }
            return new_filters;
        }

        closeDialog(): void {
            this.dialog.hide();
        }
    },
};

angular.module("filter").component(ViewFilterDialog.selector, ViewFilterDialog);
